// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"afef949a","349":"61207be6","422":"ebc4f3e6","725":"034089a9"}[chunkId] + ".chunk.js";
};